import * as React from 'react';
import { useEffect, useState } from 'react';
import UserLookup from '../../common/form-controls/Lookups/UserLookup';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import DoNotDecryptRequestService from '../../../services/DoNotDecryptRequestService';

interface ApproverInputProps extends FieldHandler<string> {
	higherApproval: boolean;
	scope?: string;
}

const ApproverInput: React.FC<ApproverInputProps> = (props) => {
	const doNotDecryptRequestService = new DoNotDecryptRequestService();

	const [moratoriumEnabled, setMoratoriumEnabled] = useState(false);

	const { higherApproval, scope, value, validation, onChange, disabled, hideNotes } = props;

	useEffect(() => {
		const fetchMoratoriumStatus = async () => {
			try {
				const moratoriumStatus = await doNotDecryptRequestService.getMoratoriumStatus();
				setMoratoriumEnabled(moratoriumStatus.enabled);
			} catch (error) {
				console.error('Failed to fetch moratorium status:', error);
			}
		};

		fetchMoratoriumStatus();
	}, []);

	const doagLevel = () => {
		var level = higherApproval ? 6 : 8;

		// this.state.moratoriumEnabled && level--;

		return level;
	};

	return (
		<UserLookup
			label={`Approver (DOAG ${doagLevel().toString()})`}
			isEmployee
			note="Select your functional management’s authority"
			value={value}
			validation={validation}
			onChange={onChange ?? (() => undefined)}
			disabled={disabled}
		/>
	);
};

export { ApproverInput };
